// 全画面のピース一覧（/courses/builder）。中身は PieceBuilderTopPage（縦タブ・ゴミばこ・詳細ページ込み）。
// 上の帯は、アプリ共通の もどる/アバター（左上）とヘルプのロゴ（右上、156x156）に一覧が重ならないように空けておく。
// タイトルは じゆうにつくる（CreatorTop）と同じ看板・同じ位置。
// Modal はページ全体（帯やアプリ共通のボタンも含む）を覆う ScreenModalProvider の層に出る

import { useState } from "react";
import I18n from "common/i18n";
import { btnDelay, useScale, usePlaySound } from "common/utils";
import { FreebuildTitleSvg } from "features/home/assets";
import { TOP_GUIDE_CHAPTERS } from "features/builder/guideBookPages";
import {
  PillSize,
  PillColor,
  GuideBookId,
  BuilderGuideBook,
  BuilderPillButton,
  ScreenModalProvider,
} from "features/builder/elements";
import { PieceBuilderTopPage } from "./PieceBuilderTopPage";

export const PieceBuilderListPage = () => {
  const play = usePlaySound();
  const { scale, width, height } = useScale();
  const [showGuide, setShowGuide] = useState(false);

  return (
    <div className="flex-col-el relative w-full h-full overflow-hidden bg-background">
      <ScreenModalProvider>
        <div
          className="flex-col-el origin-top-left"
          style={{ width: width / scale, height: height / scale, transform: `scale(${scale})` }}
        >
          {/* 帯の高さ 144：中身（一覧の右の縦タブ・詳細のボード）の上端がヘルプのロゴ（高さ 156）より下に来る最小 */}
          <div className="flex-row-el justify-center items-start relative w-full h-36 pt-4 shrink-0">
            <div className="flex-col-el flex-center w-[321px] h-16">
              <FreebuildTitleSvg text={I18n.t("MSG_BUILDER_LIST_TITLE")} />
            </div>

            {/* つかいかた（一覧・詳細で共通、いつもここ）。じゆうにつくるのガイドボタンと同じく、
                ヘルプのロゴ（幅 156）の左に置く。高さはタイトルの看板（上 16・高さ 64）の真ん中にそろえる */}
            <div
              data-guide="list_guide"
              className="flex-row-el items-center absolute top-6 right-[156px]"
            >
              <BuilderPillButton
                color={PillColor.WHITE_BLUE}
                size={PillSize.SM}
                icon="menu_book"
                label={I18n.t("MSG_BUILDER_TOP_GUIDE_BTN")}
                onClick={() => {
                  play();
                  btnDelay(() => setShowGuide(true));
                }}
              />
            </div>
          </div>

          <div className="flex-col-el relative flex-1 w-full min-h-0">
            <PieceBuilderTopPage />
          </div>
        </div>

        <BuilderGuideBook
          open={showGuide}
          book={GuideBookId.TOP}
          chapters={TOP_GUIDE_CHAPTERS}
          onClose={() => setShowGuide(false)}
        />
      </ScreenModalProvider>
    </div>
  );
};
